import axiosInstance from './axiosInstance';

export const getVapidPublicKey = () =>
    axiosInstance.get("/PushSubscription/GetVapidPublicKey");

export const subscribePush = (subscription) =>
    axiosInstance.post("/PushSubscription/Subscribe", subscription);

export const unsubscribePush = (subscription) =>
    axiosInstance.delete("/PushSubscription/Unsubscribe", { data: subscription });
